module.exports = __webpack_public_path__ + "img/8.0f4a2162.jpg";